import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import RequestStateForm from 'components/organisms/RequestStateForm';
import { StyledButtonMui5 } from 'components/atoms/StyledButton';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useScreenSize } from 'hooks/useScreenSize';

const RequestLocationButton = (): JSX.Element => {
  const { isExtraSmallScreen } = useScreenSize();
  const [isDialogOpen, toggleDialog] = useState(false);
  const [isSnackbarOpen, toggleSnackbar] = useState(false);

  return (
    <>
      <StyledButtonMui5
        color='primary'
        onClick={() => {
          toggleDialog(true);
        }}
      >
        Notify me
      </StyledButtonMui5>
      <Dialog
        fullScreen={isExtraSmallScreen}
        open={isDialogOpen}
        onClose={() => toggleDialog(false)}
        maxWidth={'xs'}
      >
        <DialogContent sx={{ pb: 2 }}>
          <Box display={'flex'} flexDirection={'column'} height={'100%'}>
            <Typography variant='h5' gutterBottom>
              Request location
            </Typography>
            <RequestStateForm
              onSubmit={() => {
                toggleSnackbar(true);
                toggleDialog(false);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={6000}
        onClose={() => toggleSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => toggleSnackbar(false)} severity='success'>
          Notification was requested
        </Alert>
      </Snackbar>
    </>
  );
};

export default RequestLocationButton;
